import styled from "styled-components/macro";
import { Switch } from "antd";

const StyledSwitch = styled(Switch)`
	color: ${({ theme }) => theme.colors.grey600};
	text-decoration: underline;
`;

export default StyledSwitch;
